import { Component, effect, inject, input, OnInit, ViewChild } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button'
import { MatTableModule, MatRow, MatTableDataSource } from '@angular/material/table'
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule, MatSort } from '@angular/material/sort';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDialog } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatCardModule } from '@angular/material/card';
import { MatMenuModule } from '@angular/material/menu';
import { style, state, trigger, transition, animate } from '@angular/animations';
import { FeedstockService } from '../../../../services/feedstockservice';
import { LabChemistryList } from '../../../../interfaces/labchemistrymodel';
import { FilterState } from '../../../../interfaces/generatorsmodel';
import { AddeditChemistryComponent } from './addedit-chemistry/addedit-chemistry.component';
import { ConfirmationDialogData, ConfirmationDialogComponent } from '../../../shared/components/confirmation-dialog/confirmation-dialog.component';
import { DatePipe } from '@angular/common';
import { NotificationService } from '../../../../services/notificationservice';
import { RolePermissionsService } from '../../../../services/role-permissions.service';
import { LoadScheduleControlFlags, ScreenName } from '../../../../interfaces/securityPermissions';
import { RoleService } from '../../../../services/role.service';
@Component({
  selector: 'app-chemistry',
  imports: [MatIcon, MatTableModule, MatRow, MatPaginatorModule, MatSortModule, MatFormFieldModule,
    MatInputModule, MatButtonModule, MatSelectModule, MatDatepickerModule,
    MatMenuModule, MatProgressBarModule, MatProgressSpinnerModule, MatCardModule],
  templateUrl: './chemistry.component.html',
  styleUrl: './chemistry.component.scss',
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ]
})
export class ChemistryComponent implements OnInit {
  permissions = inject(RolePermissionsService);
  displayedColumns: string[] = ['actions','id','c_LabName', 'c_LabreportID', 'c_DateSampled', 'c_DateTested','testingTypeName' , 'cod',
    'tvs','ts','cNratio','density','totalCarbon','ammonia','tkn','totalNitrogen','totalSulfur',
    'sulfides','phosphate','potassium','pH','sodium','calcium','magnesium','iron','methanol',
    'chlorides','oilsAndGrease','notes'
  ];
  dataSource = new MatTableDataSource<any>;
  chemistryList: LabChemistryList[] = [];
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  filterState = input<FilterState | null>(null);
  refreshTrigger = input<number>(0);
  gridSearchText = input<string | null>(null);
  controlPermissions : LoadScheduleControlFlags = new LoadScheduleControlFlags();

  constructor(private _dialog: MatDialog, private fsService: FeedstockService,
    private datePipe: DatePipe, private notificationService: NotificationService,
  private rolesService: RoleService) {
    effect(() => {
      const state = this.filterState();
      const currentRefresh = this.refreshTrigger();
      console.log("Chemistry component - refreshTrigger changed:", currentRefresh);
      console.log("Chemistry component - current filter state:", this.filterState()); 
      //if (currentRefresh > 0) {
        if (!state || state.tabIndex !== 10) return;
        const streamid = this.filterState()?.stream?.toString() || '0';
        this.getLabChemistrydata(parseInt(streamid));
      //}
    });
    
    effect(() => {
      const searchText = this.gridSearchText();
      if (this.dataSource) { 
        this.applyGridFilter(searchText ?? '');
      }
    });
    
    
    effect(() => {
      const currentFilter = this.filterState();
      if (currentFilter) {
        const streamid = currentFilter.stream?.toString() || '0';
        //this.getLabChemistrydata(parseInt(streamid));
      }
    });
  }

  ngOnInit(): void {
    
    let roles = this.rolesService.getRolesAsString();
    this.permissions.getRolePermissionsNew(roles, ScreenName.CustomerInfo, 0).subscribe({
      next: (perms: LoadScheduleControlFlags) => {
        this.controlPermissions = perms;
      }
    })
  }

  formatDate(dateString: string | null | undefined): string {
    if (!dateString) {
      return '';
    }
    return this.datePipe.transform(dateString, 'MM/dd/yyyy') || '';
  }

  getLabChemistrydata(streamid: number){
    console.log("input streamid filter", streamid);

    if(streamid == 0){
      this.chemistryList = [];
      this.dataSource = new MatTableDataSource(this.chemistryList);
      return;
    }
    this.fsService.getChemistryList(streamid).subscribe(
      {
        next: (res: LabChemistryList[]) => {
          this.chemistryList = res;
          console.log("chemistry data", this.chemistryList);
          
          if (this.dataSource) {
            this.dataSource.data = this.chemistryList;
          } else {
            this.dataSource = new MatTableDataSource(this.chemistryList);
          }
          
          this.dataSource.sort = this.sort;
          this.dataSource.paginator = this.paginator;
  
          const currentSearchText = this.gridSearchText();
          if (currentSearchText) {
              this.applyGridFilter(currentSearchText);
          }
        }
      }
    );
  }


  applyGridFilter(filterText: string) {
    const filterValue = filterText.trim().toLowerCase();
    this.dataSource.filter = filterValue;
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  openContextmenu(data: any) {

  }
  
  onOpen(row: LabChemistryList, task: string) {      
    const genId = this.filterState()?.generator?.toString() || '0';
    const dialogRef = this._dialog.open(AddeditChemistryComponent, {
      data: { 
        inputData: row,
        streamId: this.filterState()?.stream || 0,
        genId: parseInt(genId),
        task: task,
        canSave: this.controlPermissions.editChemistry
      },
      disableClose: true,
       width: '1000px',
       maxWidth: '1000px',
       maxHeight: '90vh'
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        const streamid = this.filterState()?.stream?.toString() || '0';
        this.getLabChemistrydata(parseInt(streamid));
        this.notificationService.show(`Chemistry lab data saved successfully.`, 'Success');
      }
    });
  }

  onDelete(id: number, name: string) {
    const dialogData: ConfirmationDialogData = {
      title: 'Confirm Deletion',
      message: `Are you sure you want to delete Chemistry lab: ${name}?`,
      confirmButtonText: 'Delete',
      cancelButtonText: 'Cancel',
      confirmButtonColor: 'warn'
    };

    this._dialog.open(ConfirmationDialogComponent, {
      width: '400px',
      panelClass: 'delete-confirmation-dialog',
      data: dialogData,
      disableClose: true
    }).afterClosed().subscribe(result => {
      if (result) {
        if (id !== null && id !== undefined) {
          const genId = this.filterState()?.generator?.toString() || '0';
          this.fsService.deleteChemistry(id).subscribe({
            next: () => {
              this.dataSource.data = this.dataSource.data.filter(item => item.id !== id);
              this.notificationService.show('Chemistry lab data deleted successfully.', 'Success');
            }
          });
        }
      }
    });

  }
}
